import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronLeft } from 'lucide-react';
import theme from '../theme.config';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const BRAND = theme.brand.name;

const DEFAULT_CONTENT = {
  'tentang-kami': { title: 'About Us', content: `${BRAND} is a trusted developer portal offering robust and reliable automated digital APIs and transaction routing gateways.` },
  'kebijakan-privasi': { title: 'Privacy Policy', content: `This Privacy Policy outlines how ${BRAND} collects, uses, and safeguards your transaction payloads and personal information.` },
  'syarat-ketentuan': { title: 'Terms & Conditions', content: `By connecting to and routing traffic through the ${BRAND} network, you explicitly agree to these Terms and Conditions.` },
  'hubungi-kami': { title: 'Contact Support', content: 'Reach out to our developer support team via email or support channels for routing integration assistance.' },
};

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPage();
  }, [slug]);

  const fetchPage = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/cms/${slug}`);
      const data = res.data;
      if (data.content) {
        setPage(data);
      } else {
        setPage(DEFAULT_CONTENT[slug] || { title: slug, content: '' });
      }
    } catch {
      setPage(DEFAULT_CONTENT[slug] || { title: slug, content: '' });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-16 flex items-center justify-center bg-[#09090b]">
        <div className="animate-spin w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-12 bg-[#09090b] text-zinc-50 relative">
      <div className="absolute inset-0 bg-[radial-gradient(#1c1c1f_1px,transparent_1px)] [background-size:16px_16px] opacity-10 pointer-events-none" />
      <div className="max-w-3xl mx-auto px-4 relative z-10">
        <Link to="/" className="inline-flex items-center gap-1 text-zinc-400 hover:text-white text-xs mb-6">
          <ChevronLeft className="w-4 h-4" /> Back to Home
        </Link>
        <h1 className="font-bold text-2xl text-white mb-6">
          {page?.title}
        </h1>
        <div className="bg-zinc-900/30 rounded-xl p-6 md:p-8 border border-zinc-850 prose prose-zinc prose-invert max-w-none">
          {page?.content?.split('\n').map((line, i) => (
            <p key={i} className="text-zinc-300 leading-relaxed mb-4 text-sm">{line}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
